export default __webpack_public_path__ + "static/media/yes.fffcaf44.svg";